import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  SITE_CONFIGS,
  siteIdForPath,
  siteIdFromEnv,
} from '../siteConfig/branding';
import standards from '../siteConfig/branding/standards';
import { siteIdFromState } from './siteFromState';

/**
 * Resolve the active SiteConfig for the current view.
 *
 * Resolution order (first hit wins):
 *   1. The Redux store's raw backend `@id` — the only signal that reliably
 *      carries the site segment in seamless mode. Primary source.
 *   2. An explicitly passed `content['@id']` (useful before the store settles,
 *      e.g. a freshly fetched object handed straight to a view).
 *   3. The router pathname (only meaningful on the non-seamless/dev setup).
 *
 * Falls back to `standards` so a component never renders without a brand.
 */
export function useSiteConfig(content) {
  const idFromState = useSelector(siteIdFromState);
  const location = useLocation();
  const id =
    siteIdFromEnv() ||
    idFromState ||
    siteIdForPath(content && content['@id']) ||
    siteIdForPath(location && location.pathname);
  return id ? SITE_CONFIGS[id] : standards;
}

export default useSiteConfig;
